import { string, object } from 'yup';

const schema = object().shape({
  driver_phone_number: string().required('requiredField').matches(/^[0-9]+$/, 'onlyNumbers'),
});

export default schema;